module.exports = __webpack_public_path__ + "static/media/away.d3cd6588.wav";